module.exports = __webpack_public_path__ + "media/bgm1.3fd60cd1.mp3";